import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Table, Button, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import reportService from '../../services/reportService';
import Pagination from '../../components/Pagination';
import { formatHoursToHoursMinutes, formatDecimalHours, calculateTotalHours, getStandardizedHours } from '../../utils/timeUtils';

const ViewReports = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalReports, setTotalReports] = useState(0);
  
  useEffect(() => {
    fetchReports();
  }, [currentPage]);
  
  const fetchReports = async () => {
    setLoading(true);
    try {
      const data = await reportService.getUserReports(currentPage);
      console.log('Reports fetched:', data.reports);
      
      // Force recalculation of hours_worked from task_details
      if (data.reports && Array.isArray(data.reports)) {
        for (const report of data.reports) {
          if (!report.task_details || !Array.isArray(report.task_details) || report.task_details.length === 0) {
            console.warn(`Report ${report.id} has no task_details. Will use stored hours_worked.`);
          }
        }
      }
      
      setReports(data.reports);
      setTotalPages(data.totalPages || 1);
      setTotalReports(data.total);
    } catch (err) {
      console.error('Error fetching reports:', err);
      setError('Failed to load reports');
    } finally {
      setLoading(false);
    }
  };
  
  const handlePageChange = (page) => {
    console.log('Page change requested to page:', page);
    setCurrentPage(parseInt(page, 10));
  };
  
  return (
    <div className="page-fade-in">
    <Container>
      <Row>
        <Col>
          <Card style={{ border: '1px solid #EEEEEE', borderRadius: 14 }}>
            <Card.Header style={{
              background: 'linear-gradient(135deg, #E8E0F0, #D6E6F5)',
              borderBottom: 'none', borderRadius: '14px 14px 0 0',
              padding: '0.9rem 1.25rem'
            }}>
              <div className="d-flex justify-content-between align-items-center">
                <span style={{ fontWeight: 700, color: '#7C6FA0', fontSize: '0.95rem' }}>Your Submitted Reports</span>
                <span style={{ fontWeight: 600, color: '#9E9E9E', fontSize: '0.85rem' }}>Total: {totalReports}</span>
              </div>
            </Card.Header>
            <Card.Body>
              {loading ? (
                <div className="text-center p-4">
                  <Spinner animation="border" role="status" variant="primary">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                </div>
              ) : error ? (
                <div className="alert alert-danger">{error}</div>
              ) : reports.length === 0 ? (
                <div className="text-center p-4">
                  <p>No reports found. Submit your first report!</p>
                  <Button as={Link} to="/reports/new" variant="primary">
                    Submit Report
                  </Button>
                </div>
              ) : (
                <>
                  <Table responsive striped bordered hover>
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Tasks</th>
                        {/* <th>Project</th> */}
                        <th>Hours Worked</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reports.map(report => (
                        <tr key={report.id}>
                          <td>{new Date(report.date).toLocaleDateString()}</td>
                          {/* <td>{report.project_name || 'No Project'}</td> */}
                          <td>
                            {report.tasks.length > 100
                              ? `${report.tasks.substring(0, 100)}...`
                              : report.tasks}
                          </td>
                          <td>
                            {/* {formatHoursToHoursMinutes(report.task_details && report.task_details.length > 0 ? calculateTotalHours(report.task_details) : report.hours_worked)}
                            <div className="text-muted small">({formatDecimalHours(report.task_details && report.task_details.length > 0 ? calculateTotalHours(report.task_details) : report.hours_worked)} hours)</div>
                            {(!report.task_details || report.task_details.length === 0) && (
                              <div className="text-danger" style={{fontSize: '0.7em'}}>Task details missing - showing stored hours</div>
                            )} */}
                             {formatHoursToHoursMinutes(report.task_details && report.task_details.length > 0 ? calculateTotalHours(report.task_details) : report.hours_worked)}
                          </td>

                          <td>
                             {/* <Button
                              as={Link}
                              to={`/reports/edit/${report.id}`}
                              variant="info"
                              size="sm"
                              className="me-2"
                            >
                              Edit
                            </Button> */}
                            <Button
                              as={Link}
                              to={`/reports/${report.id}`}
                              variant="primary"
                              size="sm"
                              className="me-2"
                            >
                              View
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  
                  <div className="pagination-wrapper">
                    <Pagination
                      itemsPerPage={10}
                      totalItems={totalReports}
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={handlePageChange}
                    />
                  </div>
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
    </div>
  );
};

export default ViewReports;
